import initialState from './state'

import {
	PUSH_COMPLETED_SECTION,
	PUSH_COMPLETED_SEGMENT,
	PUSH_RAW_DATA,
	RESET,
	SET_ACTIONS_OPEN,
	SET_ACTIONS_TEXT,
	SET_ACTIVE,
	SET_CAN_SKIP_STEP,
	SET_CAN_STEP_FORWARD,
	SET_DISCOUNT,
	SET_NAVIGATION_OPEN,
	SET_QUOTE,
	SET_RAW_DATA,
	SET_SELECTED_DOG
} from './actions'

export default function reducer(state: any, { type, payload }: any) {
	switch (type) {
		case SET_QUOTE:
			return {
				...state,
				planQuote: payload
			}
		case SET_ACTIVE:
			return {
				...state,
				...payload
			}
		case SET_RAW_DATA:
			return {
				...state,
				rawData: payload
			}
		case PUSH_RAW_DATA:
			return {
				...state,
				rawData: payload
			}
		case PUSH_COMPLETED_SECTION:
			return {
				...state,
				completedSections: [...state.completedSections, payload]
			}
		case PUSH_COMPLETED_SEGMENT:
			return {
				...state,
				completedSegments: [...state.completedSegments, payload]
			}
		case SET_ACTIONS_OPEN:
			return {
				...state,
				actionsOpen: payload
			}
		case SET_ACTIONS_TEXT:
			return {
				...state,
				actionsText: payload
			}
		case SET_DISCOUNT:
			return {
				...state,
				discountCode: payload
			}
		case SET_CAN_STEP_FORWARD:
			return {
				...state,
				canStepForward: payload
			}
		case SET_CAN_SKIP_STEP:
			return {
				...state,
				canSkipStep: payload
			}
		case SET_NAVIGATION_OPEN:
			return {
				...state,
				navigationOpen: payload
			}
		case SET_SELECTED_DOG:
			return {
				...state,
				rawData: {
					...state.rawData,
					selected__dog: payload
				}
			}
		case RESET:
			return { ...initialState }
		default:
			return state
	}
}
